import { useSelector } from 'react-redux';
import { RootState } from '../../store/RootState';

const useOffline = () => {
  const offline = useSelector((state: RootState) => state.offline);
  return offline;
};

export default useOffline;
